import React from 'react'
import Card from '../Card/Card'
import { MAX_CARDS, STATUS } from '../../enums/common'
import RevenueCard from './RevenueCard'
import { IRevenueCardsCollection } from '../../interfaces/Step2'
import { addMore } from '../../assets/images/images'

const RevenueCardCollection = ({
  revenueCards,
  removeRevenueCard,
  state,
  register,
  errors,
  setState,
  validateFile,
  updateRevenueCards,
  addRevenueCard,
  triggerValidation,
  multiFileUpload,
  setMultiFileUpload,
}: IRevenueCardsCollection) => {
  const partialRevenueCardProps = {
    register,
    errors,
    state,
    setState,
    validateFile,
    handleCardChange: updateRevenueCards,
    triggerValidation,
    multiFileUpload,
    setMultiFileUpload,
    revenueCards,
  }
  return (
    <>
      {revenueCards.map((item, index) => (
        <Card
          key={item.key}
          removeCard={removeRevenueCard}
          index={index}
          canBeDeleted={
            state[index].status !== STATUS.validated &&
            revenueCards.length !== 1
          }
        >
          <RevenueCard
            {...{ ...partialRevenueCardProps, index, revenue: item }}
          />
        </Card>
      ))}
      {revenueCards.length < MAX_CARDS && (
        <div
          className="dInlineFlex alignItemsCenter pointer"
          onClick={() => addRevenueCard()}
        >
          <img src={addMore} alt="addRevenue" className="mr15" />
          <span className="textPrimary fontWeightBold">
            Ajouter un autre type de revenu
          </span>
        </div>
      )}
      {revenueCards.length === MAX_CARDS && (
        <p>Vous ne pouvez pas ajouter plus de 10 types de revenu.</p>
      )}
    </>
  )
}

export default RevenueCardCollection
